import { useEffect, useState } from 'react';
import { Gallery, Item } from 'react-photoswipe-gallery';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import 'photoswipe/dist/photoswipe.css';
import EcomEngineAPI from 'api/ecom_engine_api';

const Video = ({
  videoSelect,
  videoID,
  videoThumbnail,
  thumbnailWidth,
  thumbnailHeight,
  videoDescription,
}) => {
  const [videoThumbnailSrc, setVideoThumbnailSrc] = useState(videoThumbnail);
  const videoSource = videoSelect.value;
  const videoPrefix = {
    youtube: 'https://www.youtube.com/embed/',
    vimeo: 'https://player.vimeo.com/video/',
  };
  const videoUrl = `${videoPrefix[videoSource]}${videoID}?autoplay=1&enablejsapi=1&api=1`;
  const wrappedHtml = `
    <div class="w-md-75 ratio ratio-16x9">
      <iframe
      src=${videoUrl}
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      ></iframe>
    </div>
  `;

  useEffect(() => {
    if (videoThumbnail !== null) {
      return;
    }
    if (videoSource === 'youtube') {
      setVideoThumbnailSrc(
        `https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`
      );
    }
    if (videoSource === 'vimeo') {
      EcomEngineAPI.assets.getVimeoThumbnailById(videoID).then((res) => {
        setVideoThumbnailSrc(res);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="video">
      <Gallery options={{ showHideOpacity: true }}>
        <Item html={wrappedHtml}>
          {({ open }) => (
            <div
              className="video__thumbnail image-hover darken-overlay"
              onClick={open}
            >
              <img
                alt="video thumbnail"
                src={videoThumbnailSrc}
                width={thumbnailWidth}
                height={thumbnailHeight}
              />
              <i className="fas fa-play-circle video__play-icon darken-overlay__content" />
            </div>
          )}
        </Item>
      </Gallery>
      {videoDescription && (
        <div className="mt-3">{parse(videoDescription)}</div>
      )}
    </div>
  );
};

export default Video;

Video.propTypes = {
  videoSelect: PropTypes.shape({
    value: PropTypes.string,
  }),
  videoID: PropTypes.string,
  videoThumbnail: PropTypes.string,
  thumbnailWidth: PropTypes.string,
  thumbnailHeight: PropTypes.string,
  videoDescription: PropTypes.string,
};
